import React from 'react';
import './Hero.css'
import bannerPhoto from '../../Assests/Images/Picsart_23-04-08_19-45-43-385.png'
import { TypeAnimation } from 'react-type-animation';

const Hero = () => {
  return (
    <div id='Home'>
      <section class=" background-radial-gradient overflow-hidden">

         

        <div class="px-3 py-12 lg:py-24 md:px-12 text-center lg:text-left">
          <div class=" mx-auto xl:px-32 text-gray-800">
            <div  data-aos="zoom-out" data-aos-duration="2000" class="grid lg:grid-cols-2 gap-12  flex items-center">
              <div  class="mt-12 lg:mt-0" style={{ zIndex: " 10" }}>
                <h1 class="text-4xl md:text-5xl xl:text-5xl font-bold tracking-tight mb-5 text-purple-400">Hello,<br />
                  <span className='text-3xl text-purple-300'>I'm,</span>
                  <TypeAnimation className='inline ml-2 text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-tl from-fuchsia-600 via-violet-100 to-blue-100' sequence={[
                    "Graphic Designer",
                    2000,
                    'Professional Photographer',
                    3000,
                    'Professional Video Editor',
                    3000,
                  ]}
                    cursor={true}
                    repeat={Infinity}
                    style={{ fontSize: '0.4em', }}
                  /> </h1>
                <p class='text-gray-300 text-lg'>
                  My name is Shomik Uzzaman, and I am a professional photographer and graphic designer. I have always had a passion for art and creativity, and I am constantly pushing myself to learn and improve in my field.
                </p>
              </div>
              <div class="mb-12 lg:mb-0  relative">
                <div id="radius-shape-1" class="absolute  rounded-full shadow-lg"></div>
                <div id="radius-shape-2" class="absolute  w-[220px] h-[220px]  md:w-[300px] md:h-[300px]  rounded-full shadow-lg"></div>
                <img src={bannerPhoto} alt="png" className=' z-10 w-[500px]' />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;